// extracted by mini-css-extract-plugin
export default {"button":"SecondaryButton_button__dhlqt"};